/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BridgeStatusView } from '../models/BridgeStatusView';
import type { DataSourceRequest } from '../models/DataSourceRequest';
import type { DataSourceView } from '../models/DataSourceView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DataSourceService {
    /**
     * Wawi Bridge agent status (live from the relay)
     * @returns BridgeStatusView Status
     * @throws ApiError
     */
    public static getAppDataSourceBridgeStatus(): CancelablePromise<BridgeStatusView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/ds/bridge/status',
            errors: {
                400: `DataSource is not of type bridge (errorCode: bridge_not_bridge_data_source)`,
                404: `Data source not found`,
            },
        });
    }
    /**
     * Revoke the paired Wawi Bridge agent
     * Invalidates the agent credentials; the agent can no longer connect until the user signs in again in the agent setup. The DataSource itself is kept (type stays `bridge`).
     * @returns any Revoked
     * @throws ApiError
     */
    public static postAppDataSourceBridgeRevoke(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/ds/bridge/revoke',
            errors: {
                400: `DataSource is not of type bridge`,
                403: `Subuser`,
                404: `Data source not found`,
            },
        });
    }
    /**
     * Run a round-trip test query through the Wawi Bridge
     * @returns any Agent reachable and SQL Server answered
     * @throws ApiError
     */
    public static postAppDataSourceBridgeTest(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/ds/bridge/test',
            errors: {
                400: `DataSource is not of type bridge`,
                409: `Not paired yet (errorCode: bridge_not_paired)`,
                503: `Agent offline / relay error (errorCode: bridge_agent_offline)`,
            },
        });
    }
    /**
     * Test data source connection
     * @param requestBody
     * @returns any Connection successful
     * @throws ApiError
     */
    public static postAppDataSourceTest(
        requestBody: DataSourceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/ds/test',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                500: `Connection failed`,
            },
        });
    }
    /**
     * Get data source for current user
     * @returns DataSourceView Data source retrieved successfully (masked)
     * @throws ApiError
     */
    public static getAppDataSourceGet(): CancelablePromise<DataSourceView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/ds',
            errors: {
                401: `Unauthorized`,
                404: `Data source not found`,
            },
        });
    }
    /**
     * Update data source for current user
     * Upsert: delegates to the same save handler. Requires 2FA enabled (returns errorCode `data_source_two_factor_required` with HTTP 403 otherwise).
     * @param requestBody
     * @returns any Data source updated successfully
     * @throws ApiError
     */
    public static putAppDataSourceUpdate(
        requestBody: DataSourceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/user/ds',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or connection test failed`,
                401: `Unauthorized`,
                403: `Subuser tried to modify, or 2FA is not enabled (errorCode: data_source_two_factor_required)`,
            },
        });
    }
    /**
     * Save data source for current user
     * Requires the current user to have 2FA enabled. Returns errorCode `data_source_two_factor_required` (HTTP 403) when 2FA is not active.
     * @param requestBody
     * @returns any Data source saved successfully
     * @throws ApiError
     */
    public static postAppDataSourceSave(
        requestBody: DataSourceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/ds',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error or connection test failed`,
                401: `Unauthorized`,
                403: `Subuser tried to modify, or 2FA is not enabled (errorCode: data_source_two_factor_required)`,
            },
        });
    }
    /**
     * Delete data source for current user
     * @returns any Data source deleted successfully
     * @throws ApiError
     */
    public static postAppDataSourceDelete(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/ds/delete',
            errors: {
                401: `Unauthorized`,
                404: `Data source not found`,
            },
        });
    }
}
